const getDefaultState = () => {
  return {
    selectedCodes: [],
  };
};
const state = getDefaultState;

const getters = {
  getSelectedCodes: (state) => {
    return state.selectedCodes;
  },
};

const mutations = {
  resetIcdStateMutation(state) {
    Object.assign(state, getDefaultState());
  },
  pushCode: (state, code) => {
    state.selectedCodes.push(code);
  },
  deleteCode: (state, code) => {
    state.selectedCodes.splice(state.selectedCodes.findIndex(item => item.code === code.code), 1);
  },
  spliceCode: (state, code) => {
    const currentIndex = state.selectedCodes.findIndex(item => item.order === code.order);
    if (currentIndex > -1) {
      state.selectedCodes.splice(currentIndex, 1, code);
    } else {
      state.selectedCodes.push(code);
    }
  },
};

const actions = {
  resetIcdState({ commit }) {
    commit("resetIcdStateMutation");
  },
  addCode({ commit }, code) {
    commit("pushCode", code);
  },
  replaceCode({ commit }, code) {
    commit("spliceCode", code);
  },
  removeCode({ commit }, code) {
    commit("deleteCode", code);
  },
};

export default {
  state,
  mutations,
  actions,
  getters,
};
